export default __webpack_public_path__ + "static/media/questionnaires_sent.8d9478f3.jpg";